var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !this.$route.query.hide
    ? _c("div", { staticClass: "nav_top-warpper" }, [
        _c("div", { staticClass: "fx-full", attrs: { id: "navtop" } }),
        false
          ? _c("section", [
              _c(
                "div",
                {
                  class: _vm.menubarShow
                    ? "smalllogo logo fx-none"
                    : "biglogo logo fx-none",
                },
                [
                  _c("div", {
                    class: "g-logo-" + (_vm.menubarShow ? "small" : "big"),
                    on: { click: _vm.goHome },
                  }),
                ]
              ),
              _c("div", { staticClass: "fx fx-full w-100 bgTop" }, [
                _c("div", { staticClass: "product-wrap fx-full" }, [
                  _c("div", {
                    class: "menu-" + (_vm.menubarShow ? "show" : "hide"),
                    on: { click: _vm.clickMenu },
                  }),
                ]),
                _c(
                  "div",
                  { staticClass: "nav_top_right fx-none fx" },
                  [
                    false
                      ? _c(
                          "div",
                          { staticClass: "search" },
                          [
                            _c(
                              "el-input",
                              {
                                staticClass: "input-with-select",
                                attrs: { placeholder: "搜索", size: "small" },
                                model: {
                                  value: _vm.input5,
                                  callback: function ($$v) {
                                    _vm.input5 = $$v
                                  },
                                  expression: "input5",
                                },
                              },
                              [
                                _c("el-button", {
                                  attrs: {
                                    slot: "append",
                                    size: "small",
                                    icon: "el-icon-search",
                                  },
                                  slot: "append",
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "top-menu fx" },
                      [
                        _c(
                          "div",
                          { staticClass: "action" },
                          [
                            _c(
                              "el-popover",
                              {
                                attrs: {
                                  placement: "bottom-end",
                                  "visible-arrow": false,
                                  "popper-class": "user-fee",
                                  trigger: "hover",
                                },
                                model: {
                                  value: _vm.allMenuDialog,
                                  callback: function ($$v) {
                                    _vm.allMenuDialog = $$v
                                  },
                                  expression: "allMenuDialog",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "console-wrap" },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-close",
                                      on: {
                                        click: function ($event) {
                                          _vm.allMenuDialog = false
                                        },
                                      },
                                    }),
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "search-product",
                                        attrs: {
                                          "popper-append-to-body": false,
                                          "suffix-icon": "el-icon-search",
                                          "popper-class":
                                            "search-product-dropdown",
                                          filterable: "",
                                          placeholder:
                                            "通过名称/关键词查找产品",
                                        },
                                        model: {
                                          value: _vm.searchProduct,
                                          callback: function ($$v) {
                                            _vm.searchProduct = $$v
                                          },
                                          expression: "searchProduct",
                                        },
                                      },
                                      _vm._l(
                                        _vm.filterProductList,
                                        function (item) {
                                          return _c("el-option", {
                                            key: item.ID,
                                            attrs: {
                                              label: item.Title,
                                              value: item.ID,
                                            },
                                            nativeOn: {
                                              click: function ($event) {
                                                return _vm.clickProductNav(
                                                  item.Url,
                                                  item.Title,
                                                  item.parentTitle,
                                                  item.ICon,
                                                  item.ID,
                                                  item.IsCurrentPageOpen
                                                )
                                              },
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "console-list" },
                                      _vm._l(
                                        _vm.allMenu,
                                        function (item, index) {
                                          return _c(
                                            "div",
                                            { key: index },
                                            [
                                              _c("h5", [
                                                _c("img", {
                                                  attrs: {
                                                    src: item.ICon,
                                                    alt: "",
                                                  },
                                                }),
                                                _vm._v(
                                                  " " + _vm._s(item.Title)
                                                ),
                                              ]),
                                              _vm._l(
                                                item.children,
                                                function (child, ii) {
                                                  return _c("p", { key: ii }, [
                                                    _c(
                                                      "a",
                                                      {
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.clickProductNav(
                                                              child.Url,
                                                              child.Title,
                                                              item.Title,
                                                              child.ICon,
                                                              child.ID,
                                                              child.IsCurrentPageOpen
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(child.Title)
                                                        ),
                                                      ]
                                                    ),
                                                  ])
                                                }
                                              ),
                                            ],
                                            2
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "li",
                                  {
                                    staticClass: "a-hover",
                                    attrs: { slot: "reference" },
                                    slot: "reference",
                                  },
                                  [_vm._v("全部产品")]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "action" },
                          [
                            _c(
                              "el-popover",
                              {
                                attrs: {
                                  placement: "bottom-end",
                                  width: "200",
                                  "visible-arrow": true,
                                  "popper-class": "user-fee up",
                                  trigger: "hover",
                                },
                              },
                              [
                                _c(
                                  "ul",
                                  {
                                    on: {
                                      mouseover: function ($event) {
                                        return _vm.mouseOver("fee")
                                      },
                                      mouseleave: function ($event) {
                                        return _vm.mouseLeave("fee")
                                      },
                                    },
                                  },
                                  [
                                    _vm.menuPermission(304)
                                      ? _c(
                                          "li",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.clickTopNav(
                                                  "fee/myAccount"
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("总览")]
                                        )
                                      : _vm._e(),
                                    _vm.menuPermission(305)
                                      ? _c(
                                          "li",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.clickTopNav(
                                                  "fee/feeDetail"
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("收支")]
                                        )
                                      : _vm._e(),
                                    _vm.menuPermission(306)
                                      ? _c(
                                          "li",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.clickTopNav(
                                                  "fee/orderList"
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("订单")]
                                        )
                                      : _vm._e(),
                                    _vm.menuPermission(307)
                                      ? _c(
                                          "li",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.clickTopNav(
                                                  "fee/myProduct"
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("我的产品")]
                                        )
                                      : _vm._e(),
                                    _vm.menuPermission(335)
                                      ? _c(
                                          "li",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.clickTopNav(
                                                  "fee/refund"
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("退订管理")]
                                        )
                                      : _vm._e(),
                                    _vm.menuPermission(334)
                                      ? _c(
                                          "li",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.clickTopNav(
                                                  "fee/contract"
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("合同管理")]
                                        )
                                      : _vm._e(),
                                    _vm.menuPermission(337)
                                      ? _c(
                                          "li",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.clickTopNav(
                                                  "fee/invoiceManage"
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("发票管理")]
                                        )
                                      : _vm._e(),
                                    _vm.menuPermission(304)
                                      ? _c("li", { staticClass: "li-line" })
                                      : _vm._e(),
                                    _vm.menuPermission(304)
                                      ? _c(
                                          "li",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.clickTopNav(
                                                  "fee/myAccount"
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("进入费用中心")]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                                _c(
                                  "el-badge",
                                  {
                                    staticClass: "fee",
                                    attrs: { slot: "reference" },
                                    slot: "reference",
                                  },
                                  [
                                    _vm.menuPermission(303)
                                      ? _c(
                                          "span",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.clickPermissionMenu(
                                                  "fee"
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$t("menu.fee")))]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "action" },
                          [
                            _c(
                              "el-popover",
                              {
                                attrs: {
                                  placement: "bottom-end",
                                  width: "200",
                                  "visible-arrow": true,
                                  "popper-class": "user-fee up",
                                  trigger: "hover",
                                },
                              },
                              [
                                _c(
                                  "ul",
                                  {
                                    on: {
                                      mouseover: function ($event) {
                                        return _vm.mouseOver("newWorkOrder")
                                      },
                                      mouseleave: function ($event) {
                                        return _vm.mouseLeave("newWorkOrder")
                                      },
                                    },
                                  },
                                  [
                                    _vm.menuPermission(309)
                                      ? _c(
                                          "li",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.clickTopNav(
                                                  "newWorkOrder/newWorkOrder"
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("服务申请")]
                                        )
                                      : _vm._e(),
                                    _vm.menuPermission(310)
                                      ? _c(
                                          "li",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.clickTopNav(
                                                  "newWorkOrder/myWorkOrder"
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("我的工单")]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                                _c(
                                  "el-badge",
                                  {
                                    staticClass: "newWorkOrder",
                                    attrs: { slot: "reference" },
                                    slot: "reference",
                                  },
                                  [
                                    _vm.menuPermission(308)
                                      ? _c(
                                          "span",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.clickPermissionMenu(
                                                  "newWorkOrder"
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("工单")]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "action" },
                          [
                            _c(
                              "el-popover",
                              {
                                attrs: {
                                  placement: "bottom-end",
                                  width: "200",
                                  "visible-arrow": true,
                                  "popper-class": "user-fee up",
                                  trigger: "hover",
                                },
                              },
                              [
                                _c(
                                  "ul",
                                  {
                                    on: {
                                      mouseover: function ($event) {
                                        return _vm.mouseOver("manage")
                                      },
                                      mouseleave: function ($event) {
                                        return _vm.mouseLeave("manage")
                                      },
                                    },
                                  },
                                  [
                                    _vm.menuPermission(340)
                                      ? _c(
                                          "li",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.clickTopNav(
                                                  "manage/APPImpower"
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("企业微信授权")]
                                        )
                                      : _vm._e(),
                                    _vm.menuPermission(341)
                                      ? _c(
                                          "li",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.clickTopNav(
                                                  "manage/addressBook"
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("通讯录")]
                                        )
                                      : _vm._e(),
                                    _vm.menuPermission(342)
                                      ? _c(
                                          "li",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.clickTopNav(
                                                  "manage/staffSetting"
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("子账号管理")]
                                        )
                                      : _vm._e(),
                                    _vm.menuPermission(313)
                                      ? _c(
                                          "li",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.clickTopNav(
                                                  "manage/roleSetting"
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("角色管理")]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                                _c(
                                  "el-badge",
                                  {
                                    staticClass: "manage",
                                    attrs: { slot: "reference" },
                                    slot: "reference",
                                  },
                                  [
                                    _vm.menuPermission(311)
                                      ? _c(
                                          "span",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.clickPermissionMenu(
                                                  "manage"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("menu.manage"))
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-badge",
                          {
                            staticClass: "action action-icon shopping-icon",
                            nativeOn: {
                              click: function ($event) {
                                return _vm.GoOfficialWebsite.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _c("span", { attrs: { title: "购物车" } }, [
                              _c("i"),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "action action-icon messages-icon" },
                          [
                            _c(
                              "el-popover",
                              {
                                attrs: {
                                  placement: "bottom-end",
                                  width: "310",
                                  "visible-arrow": true,
                                  "popper-class":
                                    "top-popover message-box-popover up",
                                  trigger: "hover",
                                },
                              },
                              [
                                _c("div", { staticClass: "message-box" }, [
                                  _c(
                                    "div",
                                    { staticClass: "message-box-header" },
                                    [_vm._v("消息中心")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "message-box-body" },
                                    [
                                      _c(
                                        "ul",
                                        _vm._l(
                                          _vm.messageList,
                                          function (item) {
                                            return _c(
                                              "li",
                                              {
                                                key: item.ID,
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.clickMessage(
                                                      item
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "title fx-full",
                                                  },
                                                  [
                                                    _c("text-overflow", [
                                                      _vm._v(
                                                        _vm._s(item.Title)
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "fx-none" },
                                                  [_vm._v(_vm._s(item.AddDate))]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                      !_vm.messageList.length
                                        ? _c("div", { staticClass: "empty" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "empty-img fx-ps-center",
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("@/assets/menu/unmessage.png"),
                                                    alt: "",
                                                  },
                                                }),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "empty-text" },
                                              [_vm._v("暂时没有新的站内消息")]
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "message-box-footer fx fx-ps-center",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "message-more",
                                          on: {
                                            click: function ($event) {
                                              return _vm.clickTopNav(
                                                "message/allMessage"
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("查看更多")]
                                      ),
                                    ]
                                  ),
                                ]),
                                _c(
                                  "el-badge",
                                  {
                                    staticClass: "item-icon",
                                    attrs: {
                                      slot: "reference",
                                      hidden: _vm.unreadMessageCount === 0,
                                      value: _vm.unreadMessageCount,
                                    },
                                    slot: "reference",
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        attrs: { title: "消息中心" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.clickTopNav(
                                              "message/allMessage"
                                            )
                                          },
                                        },
                                      },
                                      [_c("i")]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-badge",
                          { staticClass: "action action-icon el-question" },
                          [
                            _c(
                              "span",
                              {
                                attrs: { title: "帮助文档" },
                                on: { click: _vm.clickHelpUrl },
                              },
                              [_c("i")]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-popover",
                      {
                        attrs: {
                          placement: "bottom-end",
                          "visible-arrow": true,
                          width: "310",
                          "popper-class": "top-popover user-popover",
                          trigger: "hover",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "user-popover-header fx fx-s-center" },
                          [
                            _c("div", {
                              staticClass: "fx-none avatar",
                              style: _vm.avatar,
                            }),
                            _c(
                              "div",
                              {
                                staticClass: "fx-full",
                                staticStyle: { "font-weight": "blod" },
                              },
                              [
                                _c("text-overflow", [
                                  _vm._v(_vm._s(_vm.userName)),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "logout fx-none",
                                on: { click: _vm.signOut },
                              },
                              [_vm._v("退出")]
                            ),
                          ]
                        ),
                        _c("div", { staticClass: "user-popover-body" }, [
                          _c("div", { staticClass: "ul" }, [
                            _vm.menuPermission(315)
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "li fx",
                                    on: {
                                      click: function ($event) {
                                        return _vm.clickTopNav(
                                          "userCenter/authentication/fastAuthentication"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(_vm.$t("menu.authentication"))
                                      ),
                                    ]),
                                    _vm.authenticationStatus === 3
                                      ? _c("span", [_vm._v("待认证")])
                                      : _vm.authenticationStatus === 0
                                      ? _c("span", [_vm._v("审核中")])
                                      : _vm.authenticationStatus === 1
                                      ? _c("span", [_vm._v("已认证")])
                                      : _vm.authenticationStatus === 2
                                      ? _c("span", [_vm._v("已驳回")])
                                      : _vm._e(),
                                  ]
                                )
                              : _vm._e(),
                            _vm.menuPermission(316)
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "li fx",
                                    on: {
                                      click: function ($event) {
                                        return _vm.gotoAuthencationInfo(1)
                                      },
                                    },
                                  },
                                  [
                                    _c("div", [_vm._v("国内推广资料")]),
                                    _vm.authenticationType !== 0
                                      ? [
                                          _vm.informationStatus === 0
                                            ? _c("span", [_vm._v("审核中")])
                                            : _vm.informationStatus === 1
                                            ? _c("span", [_vm._v("已通过")])
                                            : _vm.informationStatus === 2
                                            ? _c("span", [_vm._v("已驳回")])
                                            : _c("span", [_vm._v("待完善")]),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm.menuPermission(343)
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "li fx",
                                    on: {
                                      click: function ($event) {
                                        return _vm.gotoAuthencationInfo(2)
                                      },
                                    },
                                  },
                                  [
                                    _c("div", [_vm._v("外贸推广资料")]),
                                    _vm.authenticationType !== 0
                                      ? [
                                          _vm.ftInformationStatus === 0
                                            ? _c("span", [_vm._v("审核中")])
                                            : _vm.ftInformationStatus === 1
                                            ? _c("span", [_vm._v("已通过")])
                                            : _vm.ftInformationStatus === 2
                                            ? _c("span", [_vm._v("已驳回")])
                                            : _c("span", [_vm._v("待完善")]),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                )
                              : _vm._e(),
                          ]),
                          _c("ul", { staticClass: "fx" }, [
                            _vm.menuPermission(317)
                              ? _c(
                                  "li",
                                  {
                                    staticClass: "fx-c fx-ps-center",
                                    on: {
                                      click: function ($event) {
                                        return _vm.clickTopNav(
                                          "userCenter/score"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "tm-link-score" }),
                                    _c("div", { staticClass: "li-link" }, [
                                      _vm._v("会员积分"),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "li",
                              {
                                staticClass: "fx-c fx-ps-center",
                                on: {
                                  click: function ($event) {
                                    return _vm.clickTopNav(
                                      "userCenter/information"
                                    )
                                  },
                                },
                              },
                              [
                                _c("div", {
                                  staticClass: "tm-link-information",
                                }),
                                _c("div", { staticClass: "li-link" }, [
                                  _vm._v("账户安全"),
                                ]),
                              ]
                            ),
                            _vm.menuPermission(318)
                              ? _c(
                                  "li",
                                  {
                                    staticClass: "fx-c fx-ps-center",
                                    on: { click: _vm.gotoBusiness },
                                  },
                                  [
                                    _c("div", {
                                      staticClass: "tm-link-business",
                                    }),
                                    _c("div", { staticClass: "li-link" }, [
                                      _vm._v("商家中心"),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "action action-user fx",
                            attrs: { slot: "reference" },
                            slot: "reference",
                          },
                          [
                            _c("div", { staticClass: "user-name" }, [
                              _vm._v(_vm._s(_vm.userName)),
                            ]),
                            _c("div", {
                              staticClass: "avatar",
                              style: _vm.avatar,
                            }),
                          ]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }